export const isLetter = (text) => text.toLowerCase() !== text.toUpperCase();

export const isBetweenRange = (min, max, value) => value >= min && value <= max;
